module.exports = new __parcel__URL__("explosionoflight.7e8d4552.png").toString();